<script setup lang="ts">
import { computed, watch } from 'vue'
import useLicenseControlStore from '~/stores/licenseControl'
import { useProductQuery } from '~/composables/useProductQuery'
import useProductHelper from '~/composables/useProductHelper'
import AuSpinner from '~/components/ui/AuSpinner.vue'
import NotFound from '~/components/ResourceEngine/Components/NotFound.vue'
import ProductSearchView from '~/components/products/ProductSearchView.vue'
import ProductGenericView from '~/components/products/ProductGenericView.vue'
import LegacyProductView from '~/components/products/LegacyProductView.vue'

const props = defineProps<{ locationId: number }>()

const { isSearchableProduct, isLegacyView } = useProductHelper()
const { checkItemLicense } = useLicenseControlStore()
const { data: product, isLoading, error } = useProductQuery(props.locationId)

const componentMap = computed(() => {
  if (product.value && isSearchableProduct(product.value))
    return ProductSearchView
  if (product.value && isLegacyView(product.value))
    return LegacyProductView
  return ProductGenericView
})

watch(product, () => product.value && checkItemLicense(product.value), { immediate: true })
</script>

<template>
  <NotFound v-if="error" />
  <div
    v-else-if="isLoading"
    class="absolute inset-0 flex items-center justify-center"
  >
    <AuSpinner />
  </div>
  <component
    :is="componentMap"
    v-else
    :product="product"
  />
</template>
